export default {
  fixed: {
    inserted: function (el) {
      window.addEventListener('scroll', function (e) {
        console.log(document.documentElement.clientHeight)
        const height =
          3.72 * ((document.documentElement.clientWidth * 100) / 1920)
        let scrollTop = e.target.scrollingElement.scrollTop
        if (scrollTop >= height) {
          el.style.position = 'fixed'
          el.parentElement.style.height = 0 + 'px'
          el.parentElement.style.overflow = 'hidden'
          el.parentElement.style['box-sizing'] = 'border-box'
          // el.style.height = document.body.clientHeight
          // el.style.overflow = 'hidden'
        } else {
          el.style.position = 'relative'
          el.parentElement.style.height = 'auto'
          el.parentElement.style.overflow = 'auto'
          el.parentElement.style['box-sizing'] = 'content-box'
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/index.js